import { render, staticRenderFns } from "./material-detail.vue?vue&type=template&id=945f9f1c"
import script from "./material-detail.vue?vue&type=script&lang=js"
export * from "./material-detail.vue?vue&type=script&lang=js"
import style0 from "./material-detail.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports